import _slicedToArray from "/Users/harsha919/Desktop/ONESAZ/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack, TWOPI } from '../../utils/index.js';
var min = Math.min,
  sqrt = Math.sqrt,
  acos = Math.acos;
var rgb2hsi = function rgb2hsi() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  /*
  borrowed from here:
  http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
  */
  var _unpack = unpack(args, 'rgb'),
    _unpack2 = _slicedToArray(_unpack, 3),
    r = _unpack2[0],
    g = _unpack2[1],
    b = _unpack2[2];
  r /= 255;
  g /= 255;
  b /= 255;
  var h;
  var min_ = min(r, g, b);
  var i = (r + g + b) / 3;
  var s = i > 0 ? 1 - min_ / i : 0;
  if (s === 0) {
    h = NaN;
  } else {
    h = (r - g + (r - b)) / 2;
    h /= sqrt((r - g) * (r - g) + (r - b) * (g - b));
    h = acos(h);
    if (b > g) {
      h = TWOPI - h;
    }
    h /= TWOPI;
  }
  return [h * 360, s, i];
};
export default rgb2hsi;